

import { DecodingWithOrderVal } from "./encoding";

// getMissingPackages determines the missing packages from a list of scanned orders
// It ignores any temporary qrcodes
// It returns the result as a list of couples. Each couple is in the format (order_id, `missing_package/number of packages`)
export const getMissingPackages = (decodingsWithVal: DecodingWithOrderVal[]): string[][] => {
    const result: string[][] = []
    const permanent_orders = decodingsWithVal.filter(item => item.type === "permanent")
    const sorted_permanent = permanent_orders.sort((a, b) => {
        if (a.id < b.id) return -1;
        if (a.id > b.id) return 1;

        if (a.current_package < b.current_package) return -1;
        return 1
    })

    let i = 0
    while (i < sorted_permanent.length) {

        const nbr_packages = sorted_permanent[i].number_of_packages
        const id = sorted_permanent[i].id
        const packages_found = []
        const missing_packages = []
        while (i < sorted_permanent.length && sorted_permanent[i].id == id) {
            packages_found.push(sorted_permanent[i].current_package)
            i++;
        }

        let j = 1;
        let current_package_index = 0;

        while (current_package_index < packages_found.length) {
            while (j < packages_found[current_package_index]) {
                missing_packages.push(j)
                j++;
            }
            j++;
            current_package_index++;
        }

        while (j <= nbr_packages) {
            missing_packages.push(j);
            j++;
        }

        missing_packages.forEach(item => result.push([id, `${item}/${nbr_packages}`]))
    }

    return result
}
